import Button from "@mui/material/Button";
import { styled } from "@mui/system";

const SFWhiteButton = styled(Button)(({ theme }) => ({
  backgroundColor: "white",
  color: "#A19BFD",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
  "&.MuiButton-outlined": {
    borderColor: "white",
    color: "white",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
}));

export default SFWhiteButton;
